import React from 'react';
import { SortDirection } from '@lmt/shared-types';

import SortAscIcon from '@lmt/unicorn-shared/app/icons/sort-asc.svg?react';
import SortDescIcon from '@lmt/unicorn-shared/app/icons/sort-desc.svg?react';
import SortIcon from '@lmt/unicorn-shared/app/icons/sort-none.svg?react';
const style: React.CSSProperties = {
  userSelect: 'none',
};
export const getSortIcon = (sortDirection: SortDirection | null) =>
  sortDirection === null ? (
    <SortIcon style={style} />
  ) : sortDirection === SortDirection.Asc ? (
    <SortAscIcon style={style} />
  ) : (
    <SortDescIcon style={style} />
  );

export function ScrollToTop(element: Element) {
  element.scrollTop = 0;
}
